"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ClosingCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="569" id="closing-cta" className="relative overflow-hidden bg-background py-40 text-foreground">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -right-24 top-1/2 hidden h-[140%] w-[55%] -translate-y-1/2 opacity-[0.07] md:block lg:-right-16 lg:w-[45%]">
        <svg viewBox="0 0 400 800" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-full w-full" preserveAspectRatio="xMidYMid meet">
          <g stroke="var(--primary)" strokeWidth="1.2" fill="none" strokeLinecap="round">
            {}
            <path d="M200 780 Q190 600 210 420 Q230 240 200 100" />
            {}
            <path d="M210 620 Q260 600 290 560 Q260 600 210 620 Z" fill="var(--primary)" fillOpacity="0.5" />
            <path d="M205 520 Q150 510 115 470 Q160 510 205 520 Z" fill="var(--primary)" fillOpacity="0.5" />
            <path d="M218 420 Q280 405 320 360 Q275 410 218 420 Z" fill="var(--primary)" fillOpacity="0.5" />
            <path d="M210 320 Q150 305 110 260 Q160 310 210 320 Z" fill="var(--primary)" fillOpacity="0.5" />
            {}
            <path d="M200 700 L188 690" />
            <path d="M208 580 L222 570" />
            <path d="M203 470 L189 462" />
            <path d="M214 370 L228 362" />
            {}
            <g transform="translate(200 100)">
              <circle r="42" fill="var(--primary)" fillOpacity="0.35" />
              <path d="M-30 -10 Q-10 -40 20 -30 Q40 -10 25 15 Q5 35 -20 25 Q-40 10 -30 -10 Z" fill="var(--primary)" fillOpacity="0.55" />
              <path d="M-15 -5 Q0 -22 18 -15 Q28 0 15 12 Q-2 18 -15 8 Q-22 0 -15 -5 Z" fill="var(--primary)" fillOpacity="0.7" />
              <path d="M-5 0 Q5 -10 12 -3 Q15 6 5 10 Q-5 8 -5 0 Z" fill="var(--primary)" />
            </g>
          </g>
        </svg>
      </div>

      <div ref={ref} className={`relative mx-auto max-w-4xl px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div aria-hidden="true" className="mb-8 flex justify-center font-default text-3xl text-secondary" style={{
        color: "var(--secondary)"
      }}>
          <span>&#10022;</span>
        </div>

        {}
        <p className="mb-10 font-default text-xs uppercase tracking-[0.4em] text-muted-foreground">
          Get Started
        </p>

        {}
        <div className="mx-auto mb-12 h-px w-16 bg-border" />

        {}
        <h2 className="font-default font-light italic leading-[1.05] text-foreground" style={{
        fontSize: "clamp(3rem, 7vw, 6rem)"
      }}>
          Ready to begin
          <br />
          your industrial project?
        </h2>

        {}
        <p className="mx-auto mt-10 max-w-2xl font-default text-xl italic text-muted-foreground md:text-2xl">
          Our team is ready to provide precision engraving and labeling solutions for your facility.
        </p>

        {}
        <div className="mt-14">
          <Button asChild className="h-auto rounded-lg bg-primary px-12 py-5 font-default text-sm uppercase tracking-[0.25em] text-primary-foreground shadow-md transition-all hover:bg-primary/90 hover:shadow-lg">
            <Link to="/ContactPage">Request a Quote</Link>
          </Button>
        </div>

        {}
        <div className="mt-10">
          <Link to="/ServicesPage" className="inline-flex items-center gap-2 font-default text-base italic text-primary underline decoration-primary/40 underline-offset-4 transition-colors hover:decoration-primary">
            Explore our full range of services
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        {}
        <div className="mt-20 flex items-center justify-center gap-4">
          <div className="h-px w-12 bg-border" />
          <span aria-hidden="true" className="font-default text-sm" style={{
          color: "var(--secondary)"
        }}>
            &#10022;
          </span>
          <div className="h-px w-12 bg-border" />
        </div>
      </div>
    </section>;
}